import { APP_VERSION, IS_DEVELOPMENT } from "@/lib/env";

/**
 * バージョン表示と「開発版」バッジ。
 *
 * ngtg_msc と同じく、local / dev 環境のときだけ「開発版」を赤字で出す
 * （本番では出さない）。ヘッダとログイン画面の 2 箇所で使う。
 */
export default function VersionLabel({ className }: { className?: string }) {
  return (
    <span className={className}>
      Version {APP_VERSION}
      {IS_DEVELOPMENT && (
        // ブランドカラー（青）の上でも視認できる明るい赤。
        <span className="ml-2 font-bold text-red-400">開発版</span>
      )}
    </span>
  );
}
